module.exports = __webpack_public_path__ + "static/media/medalhas2020-reputacao-19.a2fe6c74.png";